export default {
  system: {
    user: 'उपयोगकर्ता',
    level: 'स्तर',
    earnPerTap: 'प्रति टैप कमाई',
    coinsToLevelUp: 'लेवल अप के लिए सिक्के',
    profitPerHour: 'प्रति घंटा लाभ',
    coming1: 'कुछ दिलचस्प',
    coming2: 'जल्द ही यहाँ आ रहा है...',
    close: 'बंद करें',
    friends: 'मित्र',
    continue: 'जारी रखें',
  },
  settings: {
    chooseNetwork: 'नेटवर्क चुनें',
    chooseLanguage: 'भाषा चुनें',
  },
  popup_CheckTask: {
    join: 'जुड़ें',
    check: 'जाँच करें',
    taskIsNotCompleted: 'कार्य पूरा नहीं हुआ',
  },
  popup_levelUp: {
    levelUp: 'स्तर बढ़ा!',
    multiTap: 'मल्टीटैप',
    energyLimit: 'ऊर्जा सीमा',
  },
  popup_BalanceUp: {
    balanceUp: 'बैलेंस अपडेट!',
    balanceDiffSinceLast: 'आपका इनाम',
  },
  popup_BalanceTip: {
    tip: 'अपने लाभ को बढ़ाएं',
    message: 'अपने नेटवर्क के लिए अपग्रेड खरीदने के लिए माइन मेनू पर टैप करें',
    description: 'ऑफलाइन होने पर भी 3 घंटे तक कमाएं',
  },
  popup_Bored: {
    header: 'मेंढक ऊब गया है!',
    message: 'मेंढक के साथ खेलें।',
    description: 'यदि मेंढक के साथ 3 घंटे तक नहीं खेला जाता है, तो लाभ रुक जाता है',
  },
  popup_Hungry: {
    header: 'मेंढक भूखा है!',
    message: 'मेंढक को खिलाएं।',
    description: 'जितने अधिक दोस्त आपके पास हैं, उतने ही अधिक सिक्के हर बार खिलाने से मिल सकते हैं',
  },
  menu: {
    network: 'नेटवर्क',
    mine: 'खदान',
    earn: 'कमाएं',
    food: 'भोजन',
  },
  tap: {
    bored: 'उबा हुआ',
    fun: 'मज़ेदार',
  },
  mineMenu: {
    activities: 'गतिविधियाँ',
    investments: 'निवेश',
    web3: 'WEB3',
    achievements: 'उपलब्धियाँ',
  },
  leaderboard: {
    from: 'से',
    beTheFirst: 'पहले बनें!',
  },
  mine: {
    joinOurTG1: 'हमारे टेलीग्राम चैनल में शामिल हों,',
    joinOurTG2: 'अनलॉक करने के लिए!',
    unlock: 'अनलॉक करें',
  },
  friends: {
    inviteFriends: 'दोस्तों को आमंत्रित करें!',
    receiveBonuses: 'आप और आपके दोस्त को बोनस मिलेगा',
    inviteFriend: 'एक दोस्त को आमंत्रित करें',
    withTelegramPremium: 'टेलीग्राम प्रीमियम के साथ',
    forYouAndYourFriend: 'आपके और आपके दोस्त के लिए',
    moreBonuses: 'अधिक बोनस',
    listOfYourFriends: 'आपके दोस्तों की सूची',
    linkCopied: 'आमंत्रण लिंक आपके क्लिपबोर्ड पर कॉपी कर दिया गया है!',
    playWithMe:
      'मेरे साथ जुड़ें और एयरड्रॉप के माध्यम से टोकन कमाने के लिए खेलें!\n' +
      '💰 अपना उपहार पाएं! नए आने वालों के लिए +3000 सिक्के\n' +
      '🚀 क्या आपके पास टेलीग्राम प्रीमियम है? +5000 सिक्के पाएं!\n',
  },
  earn: {
    moreCoins: 'अधिक सिक्के कमाएं!',
    dailyTasks: 'दैनिक कार्य',
    dailyReward: 'दैनिक पुरस्कार',
    tasksList: 'कार्यों की सूची',
    joinOurTG: 'हमारे टेलीग्राम चैनल में शामिल हों',
    followOurX: 'हमारे X अकाउंट को फॉलो करें',
    yourAd: 'आपका विज्ञापन यहाँ हो सकता है',
    connect: 'हमारे टेलीग्राम चैनल के एडमिन से संपर्क करें',
  },
  food: {
    hungry: 'भूखा',
    full: 'पेट भरा',
    frogIsFull: 'मेंढक का पेट भर गया है',
    feed: 'खिलाएं',
    bonus: 'बोनस',
    satiety: 'तृप्ति',
    hours: 'घंटे',
  },
  toast: {
    buyCard: {
      title: 'उपलब्धि अनलॉक हुई!',
      subtitle: 'अपने मेंढक साम्राज्य को महानता की ओर ले जाने का समय 👑',
    },
    feedFrog: {
      title: 'मेंढक खुश है!',
      subtitle: 'बहुत बढ़िया! मुस्कान बनाए रखने के लिए अपने पालतू जानवर को खिलाएं 🍽️',
    },
  },
};
